module.exports = __webpack_public_path__ + "img/SER-i-2-V.1a3fa914.png";